import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLang = i18n.language;

  useEffect(() => {
    const flags = ["/images/flags/englishFlag.png", "/images/flags/albanianFlag.png"];
    flags.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  const renderFlag = () => {
    return currentLang === "sq"
      ? "/images/flags/albanianFlag.png"
      : "/images/flags/englishFlag.png";
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Trigger */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          cursor: "pointer",
          padding: "6px 10px",
          borderRadius: 6,
          userSelect: "none",
        }}
      >
        <img
          src={renderFlag()}
          alt="lang"
          style={{
            width: 28,
            height: 20,
            borderRadius: 4,
            objectFit: "cover",
          }}
        />

        {/* Dropdown Arrow */}
        <span
          style={{
            fontSize: 12,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "0.2s",
          }}
        >
          ▼
        </span>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: 6,
            padding: "6px 0",
            minWidth: 66,
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={rowStyle} onClick={() => changeLanguage("en")}>
            <img
              src="/images/flags/englishFlag.png"
              alt="English"
              style={dropdownFlag}
            />
          </div>

          <div style={rowStyle} onClick={() => changeLanguage("sq")}>
            <img
              src="/images/flags/albanianFlag.png"
              alt="Albanian"
              style={dropdownFlag}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const dropdownFlag = {
  width: 28,
  height: 20,
  borderRadius: 4,
  objectFit: "cover",
};

const rowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "6px 12px",
  cursor: "pointer",
  fontSize: 14,
};
